<template>
  <v-container>
      <v-layout row wrap>
        <v-flex xs12>

                   <v-card
                        v-if="currentProduct"
                        class="mb-5"
                        color="white lighten-1"
                        ripple
                        >
                        <v-toolbar dark color="primary">
                            <v-toolbar-side-icon @click="dialogViewProduct = false">
                            <v-icon>close</v-icon>
                                                          
                            </v-toolbar-side-icon>
                            <v-toolbar-title>View Product Details</v-toolbar-title>
                            <v-spacer></v-spacer>

                        </v-toolbar> 

                        <v-card-title text-xs-center class="font-weight-bold primary--text">
                            {{currentProduct.title}}
                        </v-card-title>

                        <v-card-text>
                            <template  v-if="currentProduct.pics && currentProduct.pics.length>0">
                            <div>
                                
                                <gallery  v-if="currentProduct.pics && currentProduct.pics.length>0" :images="currentProduct.pics" :index="index" @close="index = null"></gallery>
                                <v-avatar
                                    v-if="currentProduct.pics && currentProduct.pics.length>0"
                                    :tile=true
                                    size="120"
                                    v-for="(image, imageIndex) in currentProduct.pics"
                                    :key="imageIndex"
                                    @click="index = imageIndex"
                                >
                                    <img :src="image">
                                </v-avatar>
                        
                            </div>
                            </template>  
                            <v-divider></v-divider>
                            <v-layout row wrap>
                                <v-flex text-xs-center xs12 class="pt-2 pb-4">
                                    <v-btn raised dark :href="currentProduct.url" target="_blank">
                                        <v-icon color="white" class="pr-2">shopping_cart</v-icon>  Buy Now
                                    </v-btn>
                                </v-flex>
                                <v-flex text-xs-left xs4 class="pl-3 font-weight-bold pb-3">
                                    Price:
                                </v-flex>
                                <v-flex text-xs-left xs8 class="font-weight-bold pb-3">
                                    ${{currentProduct.price}}
                                </v-flex>   

                                <v-flex text-xs-left xs4 class="pl-3 font-weight-bold pb-3">
                                    Shipping:
                                </v-flex>
                                <v-flex text-xs-left xs8 class="font-weight-bold pb-3">
                                    <span v-if="currentProduct.shipping && currentProduct.shipping.cost===0"> Free Shipping</span><span v-else-if="currentProduct.shipping"> ${{currentProduct.shipping.cost}} est. shipping</span> <span v-else> Calc. Shipping</span>
                                </v-flex>  

                                <v-flex text-xs-left xs4 class="pl-3 font-weight-bold pb-3">
                                    Platform:
                                </v-flex>
                                <v-flex text-xs-left xs8 class="font-weight-bold pb-3">
                                    {{currentProduct.platform}}
                                </v-flex> 
                                <template v-if="currentProduct.description">
                                    <v-flex text-xs-left xs4 class="pl-3 font-weight-bold pb-3">
                                        Description:
                                    </v-flex>
                                    <v-flex text-xs-left xs8 class="font-weight-bold pb-3">
                                        {{currentProduct.description}}
                                    </v-flex> 
                                </template>
                            </v-layout>
                        </v-card-text>

                   </v-card>
  
        </v-flex>
      </v-layout>
 
  </v-container>
</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
import VueGallery from 'vue-gallery'




  export default {
      data(){
          return{
               
               currentProduct: null,
               index: null
          }

      },
    components: {
        'gallery': VueGallery
    },      
    created () {

       var provider = this.getUrlParameter('p')
       var itemid = this.getUrlParameter('itemid')
       console.log('provider ', provider)
       console.log('itemid', itemid)
   
    },      
    computed: {

    },
    watch:{
          dialogViewProduct(value) {
            if(value===false){
                this.currentProduct = null                            
            }
        } 
    },
    methods:{   
      viewProduct: function (p) {
          this.currentProduct = p
          this.dialogViewProduct = true

      }, 
     getUrlParameter: function(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
    }                        
     
    }
  }
</script>

<style>
.flexlabel{
    font-weight: bold;

}
.shadow1{
    text-shadow: 1px 1px black;
}
</style>